import gql from 'graphql-tag';

export default {
  getMyCampaigns: gql`
    fragment OcrEditField_getMyCampaigns on FlyerPage {
      userText
    }
  `,
};
